import View from 'cdna/core/view';
import VideoView from './videoView.js';
import VideoGroupView from './videoGroupView.js';
import markup from './videoPageView.html';

export default View.extend({
    el: markup,
    bindings: {   
        'Id': 'attr data-nav',
        'selected .selected': {
            changeElement(el, val, binding) {
                if (binding.current) {
                    if (val && binding.current.model.cid == val.cid) return;//dont proceed unless the model actually changes
                    binding.current.close();
                    binding.current = null;
                }
                    
                if (val) {
                    //el should be span6, so it's ~48% of the total width. 
                    var width = binding.view.$el.width() * .4; //less 8% should deal with padding and such
                    var height = Math.floor(width * 0.50);

                    binding.current = new VideoView({ model: val, width: width, height: height }).render();
                    el.append(binding.current.$el);
                }
            },
            uninitialize: function(binding) {
                if (!binding.current) return;

                binding.current.close();
                binding.current = null;
            }
        },
        'Groups .list': 'collection videoGroupBindings videoGroupBindings'
    },  
    events: {
        'click .video-line': 'showVideo',
    },
    videoGroupBindings: {
        itemView: VideoGroupView
    },
    render() {
        //attempt to force a selection
        var groups = this.model.get('Groups');
        if (!this.model.get('selected') && groups) {
            var group = groups.find(group => {
                var videos = group.get('Videos');
                return videos && videos.length;
            });

            if (group) {
                _.delay(() => {            
                    var video = group.get('Videos').first();
                    this.model.set('selected', video);
                });
            }
        }

        return this;
    },
    showVideo(ev) {
        var el = $(ev.currentTarget);
        var modelId = el.attr('video-id');
        
        var video = this.model.getVideoById(modelId);
        this.model.set('selected', video);
    }
})


/** WEBPACK FOOTER **
 ** ./client/video/videoPageView.js
 **/